type AdminMobileSearchInputProps = {
  onNavigate: () => void;
};

export const AdminMobileSearchInput = ({ onNavigate }: AdminMobileSearchInputProps) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const searchTerm = String(data.get('search') ?? '').trim();

    if (!searchTerm) return;

    const clientUrl = process.env.LECARTTE_CLIENT_URL || 'http://localhost:3015';
    window.location.href = `${clientUrl}/buscar/${encodeURIComponent(searchTerm)}`;
    onNavigate();
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex items-center gap-3 rounded-xl border border-slate-200 px-4 py-2.5 transition focus-within:border-slate-300">
        <svg viewBox="0 0 24 24" className="h-4 w-4 flex-shrink-0 text-slate-400" fill="none" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35m1.85-5.4a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        <input
          name="search"
          type="search"
          placeholder="Buscar restaurantes..."
          className="flex-1 bg-transparent text-sm text-slate-900 outline-none placeholder:text-slate-400"
        />
      </div>
    </form>
  );
};
